import React, { useEffect, useState } from "react";
import { ImUsers } from "react-icons/im";
import { FaBuffer } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa6";
import axios from "axios";
import { TbRuler3 } from "react-icons/tb";

function StatsRow() {
  const [stats, setStats] = useState([]);
  const [members, setMembers] = useState(0);
  const [branches, setBranches] = useState(0);
  const [events, setEvents] = useState();
  const [scanners, setScanners] = useState();
  const [loading, setLoading] = useState({});

  const getStats = async () => {
    setLoading(TbRuler3);
    try {
      const res = await axios.get(`
        https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-statsrow`);
      let retcode = res.data;
      //delare empty array
      //console.log(retcode[0].members);
      setMembers(retcode[0].members);
      setBranches(retcode[0].branches);
      setEvents(retcode[0].events);
      setScanners(retcode[0].scanners);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get all events =>" + error);
    }
  };
  useEffect(() => {
    getStats();
  }, []);
  return (
    <div className="row">
      {/* Cards */}
      <div className="col-md-3">
        <div
          className="p-3 mb-4 text-secondary shadow"
          style={{ backgroundColor: "#fff", color: "white", borderRadius: 15 }}
        >
          <div className="row">
            <div className="col-9 mb-3">
              <small style={{ fontSize: 14 }}>Registered members</small>{" "}
            </div>
            <div className="col-3">
              <ImUsers size={28} style={{ color: "#5f58d8" }} />
            </div>
          </div>
          <h4 style={{ marginTop: "-10px", color: "#5f58d8" }}>{members}</h4>
          <div
            className="w-25"
            style={{ backgroundColor: "#f1f5f7", height: "2px" }}
          />
          <small className="text-success">+0.0%</small>{" "}
          <small style={{ fontStyle: "italic" }}>Since last month</small>
        </div>
      </div>
      <div className="col-md-3">
        <div
          className="p-3 mb-4 text-secondary shadow"
          style={{ backgroundColor: "#fff", color: "white", borderRadius: 15 }}
        >
          <div className="row">
            <div className="col-9 mb-3">
              <small style={{ fontSize: 14 }}>Live branches</small>{" "}
            </div>
            <div className="col-3">
              <FaBuffer size={28} style={{ color: "#716caf" }} />
            </div>
          </div>
          <h4 style={{ marginTop: "-10px", color: "#716caf" }}>{branches}</h4>
          <div
            className="w-25"
            style={{ backgroundColor: "#f1f5f7", height: "2px" }}
          />
          <small className="text-danger">+2.5%</small>{" "}
          <small style={{ fontStyle: "italic" }}>Since last month</small>
        </div>
      </div>
      <div className="col-md-3">
        <div
          className="p-3 mb-4 text-secondary shadow"
          style={{ backgroundColor: "#fff", color: "white", borderRadius: 15 }}
        >
          <div className="row">
            <div className="col-9 mb-3">
              <small style={{ fontSize: 14 }}>Total events</small>{" "}
            </div>
            <div className="col-3">
              <FaChartLine size={27} style={{ color: "#3bc0c3" }} />
            </div>
          </div>
          <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>{events}</h4>
          <div
            className="w-25"
            style={{ backgroundColor: "#f1f5f7", height: "2px" }}
          />
          <small className="text-info">+0.0%</small>{" "}
          <small style={{ fontStyle: "italic" }}>Since last month</small>
        </div>
      </div>
      <div className="col-md-3">
        <div
          className="p-3 mb-4 text-secondary shadow"
          style={{ backgroundColor: "#fff", color: "white", borderRadius: 15 }}
        >
          <div className="row">
            <div className="col-9 mb-3">
              <small style={{ fontSize: 14 }}>Total scanners</small>{" "}
            </div>
            <div className="col-3">
              <ImUsers size={28} style={{ color: "#33afe0" }} />
            </div>
          </div>
          <h4 style={{ marginTop: "-10px", color: "#33afe0" }}>{scanners}</h4>
          <div
            className="w-25"
            style={{ backgroundColor: "#f1f5f7", height: "2px" }}
          />
          <small className="text-warning">+0.0%</small>{" "}
          <small style={{ fontStyle: "italic" }}>Since last month</small>
        </div>
      </div>
    </div>
  );
}
export default StatsRow;
